import { baseApi } from 'core/api/base'
import {
  IKeycloakUtilisateur,
  IKeycloakUtilisateurCollection,
} from 'core/interfaces/User'
import { generatePath } from 'react-router'

const KEYCLOAK_UTILISATEURS_ENDPOINT =
  '/clients/:idClient/keycloak-utilisateurs'
const KEYCLOAK_UTILISATEUR_ENDPOINT =
  '/clients/:idClient/keycloak-utilisateurs/:id'

const keycloakUtilisateursApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllKeycloakUsers: builder.query<
      IKeycloakUtilisateurCollection,
      { idClient: number; search?: string; page?: number }
    >({
      query: ({ idClient, search = '', page = 1 }) => ({
        url: generatePath(KEYCLOAK_UTILISATEURS_ENDPOINT, {
          idClient: idClient.toString(),
        }),
        params: { search, page },
      }),
      providesTags: (result) =>
        result?.users
          ? [
              ...result.users.map((user: IKeycloakUtilisateur) => ({
                type: 'KeycloakUser' as const,
                id: user.id,
              })),
              { type: 'KeycloakUser', id: 'LIST' },
            ]
          : [{ type: 'KeycloakUser', id: 'LIST' }],
    }),
    getKeycloakUser: builder.query<
      IKeycloakUtilisateur,
      { idClient: number; id: string }
    >({
      query: ({ idClient, id }) =>
        generatePath(KEYCLOAK_UTILISATEUR_ENDPOINT, {
          idClient: idClient.toString(),
          id: id,
        }),
      providesTags: (result, error, { id }) => [{ type: 'KeycloakUser', id }],
    }),
    updateKeycloakUser: builder.mutation<
      IKeycloakUtilisateur,
      {
        idClient: number
        id: string
        tagsUtilisateur: number[]
        tagsAdministrateur: number[]
      }
    >({
      query: ({ idClient, id, tagsUtilisateur, tagsAdministrateur }) => ({
        url: generatePath(KEYCLOAK_UTILISATEUR_ENDPOINT, {
          idClient: idClient.toString(),
          id: id,
        }),
        method: 'PATCH',
        body: { tagsUtilisateur, tagsAdministrateur },
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'KeycloakUser', id },
        { type: 'KeycloakUser', id: 'LIST' },
      ],
    }),
  }),
})

export const {
  useGetAllKeycloakUsersQuery,
  useGetKeycloakUserQuery,
  useUpdateKeycloakUserMutation,
} = keycloakUtilisateursApi
export { keycloakUtilisateursApi }
